import { render, staticRenderFns } from "./ShowTripInfo.vue?vue&type=template&id=3ffbc2ba&scoped=true&"
import script from "./ShowTripInfo.vue?vue&type=script&lang=js&"
export * from "./ShowTripInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowTripInfo.vue?vue&type=style&index=0&id=3ffbc2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbc2ba",
  null
  
)

export default component.exports